// Accordion Menu
$.fn.uxeAccordionMenu = function (options, target) {
  var $el = $(this)
  var $prev;
  var settings = $.extend({
    'selector' : 'js-accordion',
    'itemSelector' : '.accordion_title',
    'itemClass': 'js-accordion-item',
    'navigation' : '.btn_accordion',
    'itemContents' : '.accordion_contents-b',
    'activeItemClass': 'active',
    'clickedShowOnly': false,
    'speed': 200
  }, options);

  if(target){
    $prev = $(target).find(settings.navigation)[0];
  }
  return $el.each(function(){
    var $this = $(this);
    var $nav = $(this).find(settings.navigation);
    $this.addClass(settings.selector).find(settings.itemSelector).addClass(settings.itemClass);
    $nav.each(function(){
      $(this).off("click").on("click", function(e){
        e.preventDefault();
        if(settings.clickedShowOnly === true && $prev !== this){
           $el.find('> .'+settings.itemClass).removeClass(settings.activeItemClass)
           .parent().find('> '+settings.itemContents).slideUp(settings.speed);

          // $(this).parents('.'+settings.itemClass).siblings().removeClass(settings.activeItemClass).parent().siblings().find(settings.itemContents).slideUp(settings.speed);
        }
        $(this).parents('.'+settings.itemClass).toggleClass(settings.activeItemClass).parent().find(settings.itemContents).slideToggle(settings.speed);
        $prev = this
      });
    });
  });
};

//스크롤 시, 특정 이하 단에서 fixed
$.fn.uxePositionFix = function (options) {
  var settings = $.extend({
    'selector' : 'js-uxeposfix',
    'limitSelector': '.cart_product-area',
    'limitPlus': null,
    'fixClass': 'fixed',
    'ctrlTop': 0,
    'offsetValue': 0,
    'wrapHeightNeccessary' : false,
    'useBottomLimit' : false,
    'bottomLimitSelector' : '#footer',
    'scondBottomLimitSelector' : null
  },options);
  return this.each(function(){
    var $this = $(this);
    $this.addClass(settings.selector);
    var offsetTop = $this.offset().top;
    var sTop;
    var ctrlTop = settings.ctrlTop;
    var $limitObj = $(settings.limitSelector);
    if(settings.useBottomLimit === true ){
      var $bottomlimitObj = $(settings.bottomLimitSelector);
    }
    var minusTop = 0;
    var fixedCtrl =  function(){
      var sTop = $(document).scrollTop();
      var limit = $limitObj.offset().top + (settings.offsetValue) - settings.ctrlTop;
      if(settings.useBottomLimit === true) var bottomlimit = $bottomlimitObj.offset().top;
      if(settings.scondBottomLimitSelector !== null ){
        var secondbottomlimit = $(settings.scondBottomLimitSelector).offset().top;
      }

      if( settings.useBottomLimit === true && $(window).height()  > bottomlimit - limit || (settings.scondBottomLimitSelector !== null && $(window).height() > secondbottomlimit - limit)){
        $this.removeClass(settings.fixClass);
        minusTop = 0;
        if(ctrlTop !== 0){
          $this.css('top','');
        }
      }

      else if(settings.useBottomLimit === true && sTop > (bottomlimit-$(window).height()) && bottomlimit - limit > $(window).height()){
        var minustop = bottomlimit - sTop + settings.ctrlTop-$(window).height() - 55;
        $this.css('top', minustop).addClass(settings.fixClass);
        //$this.removeClass(settings.fixClass);
      }
      else if(sTop < limit && ($this.hasClass('on') == false) ){
        $this.removeClass(settings.fixClass);
        minusTop = 0;
        if(ctrlTop !== 0){
          $this.css('top','');
        }else{$this.removeAttr('style');}

      }
      else if (sTop >= limit){
        //$this.addClass(settings.fixClass);
        $this.addClass(settings.fixClass).css('top',settings.ctrlTop);
      } else{}
    };

    fixedCtrl();
    $(window).scroll(function(e){
      fixedCtrl();
    });
  });
};

/* 장바구니,주문결제 툴팁 */
export function promotionTooltip(){
  if(!$('.tooltip-btn').length){return;}

  $('.tooltip-btn').each(function(){
    var _this = $(this);

    //다른 툴팁 찾기
    var parentsRow = _this.parents('.product-list-item');
    var $parentsSiblings = parentsRow.siblings('.product-list-item').find('.promotion-tip-alert');
    //this
    var $promotionTip = _this.parents('.promotion').find('.promotion-tip-alert');
    var $tip_closeBtn = $promotionTip.find('.tip-close');

    _this.on('click',function(){
      //열린 툴팁 닫기
      $parentsSiblings.hide();

      if($promotionTip.is(':hidden')){
        $promotionTip.show();
      } else if($promotionTip.is(':visible')){
        $promotionTip.hide();
      }
    });

    $tip_closeBtn.on('click',function(){
      $promotionTip.hide();
    });
  });
}


// WEBPACK FOOTER //
// ./src/utils/publishedJs.js